import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function Variables() {
  const { t } = useTranslation();
  const image001 = useDocImage('variables-img', 'image001.png');
  const image002 = useDocImage('variables-img', 'image002.png');
  const image003 = useDocImage('variables-img', 'image003.png');
  const image004 = useDocImage('variables-img', 'image004.png');
  const image005 = useDocImage('variables-img', 'image005.png');
  const image006 = useDocImage('variables-img', 'image006.png');
  const image007 = useDocImage('variables-img', 'image007.png');
  const image008 = useDocImage('variables-img', 'image008.png');
  const image009 = useDocImage('variables-img', 'image009.png');
  const image010 = useDocImage('variables-img', 'image010.png');
  const image011 = useDocImage('variables-img', 'image011.png');
  const image012 = useDocImage('variables-img', 'image012.png');
  const image013 = useDocImage('variables-img', 'image013.png');
  const image014 = useDocImage('variables-img', 'image014.png');
  const image015 = useDocImage('variables-img', 'image015.png');
  const image016 = useDocImage('variables-img', 'image016.png');
  const image017 = useDocImage('variables-img', 'image017.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.variables.title')}</h1>
              <p className='header-para'>
                {t('documentation.variables.intro')}
              </p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.accessingVariables.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>{t('documentation.variables.accessingVariables.steps.step1')}
                      <img src={image001} alt={t('documentation.variables.accessingVariables.imageAlt1')} className='img-fluid pb-20 pt-20' />
                    </li>
                    <li>{t('documentation.variables.accessingVariables.steps.step2')} <br />
                      <img src={image002} alt={t('documentation.variables.accessingVariables.imageAlt2')} className='img-fluid pt-20 pb-20' />
                    </li>

                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.leadGenVariable.title')}
                </div>
                <div className="card-body">
                  <img src={image003} alt={t('documentation.variables.leadGenVariable.imageAlt')} className='img-fluid pt-20 pb-30' />
                  <p>{t('documentation.variables.leadGenVariable.intro')}</p>
                  <p>{t('documentation.variables.leadGenVariable.usage')}</p>
                  <p>{t('documentation.variables.leadGenVariable.example')}</p>
                  <ul>
                    <li>{t('documentation.variables.leadGenVariable.exampleFields.firstName')}</li>
                    <li>{t('documentation.variables.leadGenVariable.exampleFields.lastName')}</li>
                    <li>{t('documentation.variables.leadGenVariable.exampleFields.email')}</li>
                  </ul>

                  <p>{t('documentation.variables.leadGenVariable.displayValue')}</p>
                  <p>{t('documentation.variables.leadGenVariable.dynamicReplacement')}</p>
                  <p>{t('documentation.variables.leadGenVariable.notesTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.leadGenVariable.notes.note1')}</li>
                    <li>{t('documentation.variables.leadGenVariable.notes.note2')}</li>
                    <li>{t('documentation.variables.leadGenVariable.notes.note3')}</li>
                  </ul>
                  <p>{t('documentation.variables.leadGenVariable.conclusion')}</p>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.customVariables.title')}
                </div>
                <div className="card-body">
                  <img src={image004} alt={t('documentation.variables.customVariables.imageAlt')} className='img-fluid pt-20 pb-30' />
                  <p>{t('documentation.variables.customVariables.intro')}</p>
                  <p>{t('documentation.variables.customVariables.usage')}</p>
                  <p>{t('documentation.variables.customVariables.example')}</p>
                  <p>{t('documentation.variables.customVariables.displayValue')}</p>
                  <p>{t('documentation.variables.customVariables.dynamicReplacement')}</p>
                  <p>{t('documentation.variables.customVariables.notesTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.customVariables.notes.note1')}</li>
                    <li>{t('documentation.variables.customVariables.notes.note2')}</li>
                    <li>{t('documentation.variables.customVariables.notes.note3')}</li>
                    <li>{t('documentation.variables.customVariables.notes.note4')}</li>
                  </ul>

                  <p>{t('documentation.variables.customVariables.conclusion')}</p>

                  <p><b>{t('documentation.variables.customVariables.editTitle')}</b></p>
                  <img src={image005} alt={t('documentation.variables.customVariables.imageAltEdit')} className=' pt-10 pb-30' />
                  <p>{t('documentation.variables.customVariables.editIntro')}</p>
                  <p>{t('documentation.variables.customVariables.editStepsTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.customVariables.editSteps.step1')}</li>
                    <li>{t('documentation.variables.customVariables.editSteps.step2')}</li>
                    <li>{t('documentation.variables.customVariables.editSteps.step3')}</li>
                    <li>{t('documentation.variables.customVariables.editSteps.step4')}</li>
                    <li>{t('documentation.variables.customVariables.editSteps.step5')}</li>
                    {t('documentation.variables.customVariables.editSteps.conclusion')}
                  </ul>

                  <p><b>{t('documentation.variables.customVariables.deleteTitle')}</b></p>
                  <img src={image006} alt={t('documentation.variables.customVariables.imageAltDelete')} className=' pt-10 pb-20' />
                  <ul>
                    <li>
                      {t('documentation.variables.customVariables.deleteIntro')}
                    </li>
                  </ul>

                  <p><b>{t('documentation.variables.customVariables.addTitle')}</b></p>
                  <img src={image007} alt={t('documentation.variables.customVariables.imageAltAddButton')} className=' pt-10 pb-10' /> <br />
                  <img src={image008} alt={t('documentation.variables.customVariables.imageAltAdd')} className=' pt-10 pb-20' />
                  <p>{t('documentation.variables.customVariables.addIntro')}</p>
                  <ul>
                    <li>{t('documentation.variables.customVariables.addFields.label')}</li>
                    <li>{t('documentation.variables.customVariables.addFields.type')}</li>
                    <li>{t('documentation.variables.customVariables.addFields.name')}</li>
                    <li>{t('documentation.variables.customVariables.addFields.description')}</li>
                  </ul>
                  <p>{t('documentation.variables.customVariables.addConclusion')}</p>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.customFormula.title')}
                </div>
                <div className="card-body">
                  <img src={image009} alt={t('documentation.variables.customFormula.imageAlt')} className='img-fluid pt-10 pb-30' />
                  <p>{t('documentation.variables.customFormula.intro')}</p>
                  <p>{t('documentation.variables.customFormula.usage')}</p>
                  <p>{t('documentation.variables.customFormula.example')}</p>
                  <p>{t('documentation.variables.customFormula.displayValue')}</p>
                  <p>{t('documentation.variables.customFormula.formulaDefinition')}</p>
                  <p>{t('documentation.variables.customFormula.usageExample')}</p>
                  <p>{t('documentation.variables.customFormula.notesTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.customFormula.notes.note1')}</li>
                    <li>{t('documentation.variables.customFormula.notes.note2')}</li>
                    <li>{t('documentation.variables.customFormula.notes.note3')}</li>
                    <li>{t('documentation.variables.customFormula.notes.note4')}</li>
                  </ul>

                  <p className='pb-10'>{t('documentation.variables.customFormula.conclusion')}</p>

                  <p><b>{t('documentation.variables.customFormula.editTitle')}</b></p>
                  <img src={image010} alt={t('documentation.variables.customFormula.imageAltEdit')} className=' pt-10 pb-20' />
                  <p>{t('documentation.variables.customFormula.editIntro')}</p>
                  <p>{t('documentation.variables.customFormula.editStepsTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.customFormula.editSteps.step1')}</li>
                    <li>{t('documentation.variables.customFormula.editSteps.step2')}</li>
                    <li>{t('documentation.variables.customFormula.editSteps.step3')}</li>
                    <li>{t('documentation.variables.customFormula.editSteps.step4')}</li>
                    <li>{t('documentation.variables.customFormula.editSteps.step5')}</li>
                    {t('documentation.variables.customFormula.editSteps.conclusion')}
                  </ul>

                  <p><b>{t('documentation.variables.customFormula.deleteTitle')}</b></p>
                  <img src={image011} alt={t('documentation.variables.customFormula.imageAltDelete')} className='pt-10 pb-20' />
                  <p>{t('documentation.variables.customFormula.deleteIntro')}</p>
                  <p>{t('documentation.variables.customFormula.deleteWarning1')}</p>
                  <p>{t('documentation.variables.customFormula.deleteWarning2')}</p>
                  <p>{t('documentation.variables.customFormula.deleteStepsTitle')}</p>
                  <ul>
                    <li>{t('documentation.variables.customFormula.deleteSteps.step1')}</li>
                    <li>{t('documentation.variables.customFormula.deleteSteps.step2')}</li>
                    <li>{t('documentation.variables.customFormula.deleteSteps.step3')}</li>
                  </ul>
                  <p>{t('documentation.variables.customFormula.deleteWarning3')}</p>
                  <p className='pb-10'>{t('documentation.variables.customFormula.deleteConclusion')}</p>

                  <p><b>{t('documentation.variables.customFormula.addTitle')}</b></p>
                  <img src={image012} alt={t('documentation.variables.customFormula.imageAltAdd')} className=' pt-10 pb-20' />
                  <p>{t('documentation.variables.customFormula.addIntro')}</p>
                  <p>{t('documentation.variables.customFormula.addFieldIntro')}</p>
                    <img src={image013} alt={t('documentation.variables.customFormula.imageAltOperators')} className='pt-20 pb-20' />
                  <p>{t('documentation.variables.customFormula.operatorsIntro')}</p>
                  <ul>
                    <li>{t('documentation.variables.customFormula.operators.addition')}</li>
                    <li>{t('documentation.variables.customFormula.operators.subtraction')}</li>
                    <li>{t('documentation.variables.customFormula.operators.multiplication')}</li>
                    <li>{t('documentation.variables.customFormula.operators.division')}</li>
                    <li>{t('documentation.variables.customFormula.operators.brackets')}</li>
                    <li>{t('documentation.variables.customFormula.operators.variable')}</li>
                  </ul>
                  <p>{t('documentation.variables.customFormula.operatorsConclusion')}</p>
                  <p>{t('documentation.variables.customFormula.precedenceIntro')}</p>
                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.customFormula.precedence.parentheses') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.customFormula.precedence.exponents') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.customFormula.precedence.multiplicationDivision') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.customFormula.precedence.additionSubtraction') }}></li>
                  </ul>
                  <p>{t('documentation.variables.customFormula.precedenceNote')}</p>
                  <p>{t('documentation.variables.customFormula.precedenceConclusion')}</p>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.utmVariables.title')}
                </div>
                <div className="card-body">
                  <img src={image014} alt={t('documentation.variables.utmVariables.imageAlt')} className='img-fluid pt-10 pb-20' />
                  <p>{t('documentation.variables.utmVariables.intro')}</p>
                  <p>{t('documentation.variables.utmVariables.context')}</p>

                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.utmVariables.source') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.utmVariables.medium') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.variables.utmVariables.campaign') }}></li>
                  </ul>

                  <p>{t('documentation.variables.utmVariables.conclusion')}</p>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.variables.stages.title')}
                </div>
                <div className="card-body">
                <img src={image015} alt={t('documentation.variables.stages.imageAlt')} className='img-fluid pt-20 pb-20' />
                  <p>{t('documentation.variables.stages.intro')}</p>
                  <p>{t('documentation.variables.stages.summary')}</p>
                  <p>{t('documentation.variables.stages.addTitle')}</p>
                  <img src={image016} alt={t('documentation.variables.stages.imageAlt')} className='w-60 pt-20 pb-20' />
                  <ul>
                    <li>{t('documentation.variables.stages.addSteps.step1')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step2')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step3')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step4')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step5')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step6')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step7')}</li>
                    <li>{t('documentation.variables.stages.addSteps.step8')}</li>
                  </ul>

                  <p>{t('documentation.variables.stages.addConclusion')}</p>
                  <p>{t('documentation.variables.stages.editTitle')}</p>
                  <img src={image017} alt={t('documentation.variables.stages.imageAltEdit')} className='w-70 pt-20 pb-30' />
                  <ul>
                    <li>{t('documentation.variables.stages.editSteps.step1')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step2')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step3')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step4')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step5')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step6')}</li>
                    <li>{t('documentation.variables.stages.editSteps.step7')}</li>
                  </ul>
                  <p>{t('documentation.variables.stages.deleteTitle')}</p>
                  <ul>

                    <li>{t('documentation.variables.stages.deleteSteps.step1')}</li>
                    <li>{t('documentation.variables.stages.deleteSteps.step2')}</li>
                    <li>{t('documentation.variables.stages.deleteSteps.step3')}</li>
                    <li>{t('documentation.variables.stages.deleteSteps.step4')}</li>
                  </ul>
                  <p>{t('documentation.variables.stages.deleteWarning')}</p>
                  <p>{t('documentation.variables.stages.conclusion')}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
